// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39Rzv","title":"Header_title__2hFDA","left":"Header_left__28Ycz","clinicName":"Header_clinicName__2-ts_"};